/**
 *
 * FlashCardLanding
 *
 */

import { FlashCardItemMixin } from '@/scripts/FlashCard/FlashCardLanding/mixins/FlashCardItemMixin';

export default {
  name: 'FlashCardItem',

  mixins: [FlashCardItemMixin],
};
